module.exports = __webpack_public_path__ + "static/media/lv2-3c.47727c83.mp3";